import * as React from 'react';
import { Route, useBaseNavigation } from './NavigationContext';

type ScreenProps = {
  route: Route['name'];
};

const Screen = ({ route, children }: React.PropsWithChildren<ScreenProps>) => {
  const { currentRoute } = useBaseNavigation();
  if (currentRoute !== route) return null;
  return children;
};

export default Screen;
